import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#050506] border-t border-[#2A2B31] pt-16 pb-28 lg:pb-8 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 mb-14">
          <div className="md:col-span-1">
            <img src="/tt-logo.png" alt="TT Motorsports" className="h-16 w-auto mb-4" />
            <p className="text-[#9A9CA3] text-sm leading-relaxed">
              Jouw specialist in verkoop, onderhoud en herstelling van motoren. Vakmanschap en passie sinds dag één.
            </p>
            <div className="flex gap-3 mt-5">
              <a href="https://www.facebook.com/profile.php?id=61573825629710" target="_blank" rel="noreferrer"
                 data-testid="footer-facebook"
                 className="w-10 h-10 flex items-center justify-center border border-[#2A2B31] text-[#9A9CA3] hover:border-[#E10600] hover:text-[#E10600] transition-colors">
                <Facebook size={18} />
              </a>
              <a href="https://www.instagram.com/tt_motorsports/" target="_blank" rel="noreferrer"
                 data-testid="footer-instagram"
                 className="w-10 h-10 flex items-center justify-center border border-[#2A2B31] text-[#9A9CA3] hover:border-[#E10600] hover:text-[#E10600] transition-colors">
                <Instagram size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display uppercase font-700 text-white tracking-wide mb-4">Navigatie</h4>
            <ul className="space-y-2.5 text-sm">
              {[["Home","/"],["Over ons","/over"],["Diensten","/diensten"],["Tweedehands motoren","/motoren"],["Afspraak maken","/afspraak"],["Contact","/contact"]].map(([label,to]) => (
                <li key={to}><Link to={to} className="text-[#9A9CA3] hover:text-[#E10600] transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display uppercase font-700 text-white tracking-wide mb-4">Diensten</h4>
            <ul className="space-y-2.5 text-sm">
              {[["Motoronderhoud","/motoronderhoud"],["Motorherstellingen","/motorherstellingen"],["Crossmotor onderhoud","/crossmotor-onderhoud"],["Enduro onderhoud","/enduro-onderhoud"],["Baanmotor onderhoud","/baanmotor-onderhoud"],["Motoronderdelen","/motoronderdelen"]].map(([label,to]) => (
                <li key={to}><Link to={to} className="text-[#9A9CA3] hover:text-[#E10600] transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display uppercase font-700 text-white tracking-wide mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-[#9A9CA3]">
              <li className="flex items-start gap-3"><MapPin size={17} className="text-[#E10600] mt-0.5 shrink-0" /> Beekstraat 4C, 8820 Torhout</li>
              <li className="flex items-center gap-3"><Phone size={17} className="text-[#E10600] shrink-0" /> <a href="tel:0485741524" className="hover:text-white">0485 74 15 24</a></li>
              <li className="flex items-center gap-3"><Mail size={17} className="text-[#E10600] shrink-0" /> <a href="mailto:TTmotorsports@outlook.com" className="hover:text-white">TTmotorsports@outlook.com</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display uppercase font-700 text-white tracking-wide mb-4">Openingsuren</h4>
            <ul className="space-y-1.5 text-sm text-[#9A9CA3] font-mono-tt">
              <li className="flex justify-between gap-4"><span>Ma – Vr</span><span className="text-white">9–12 / 13–18:30</span></li>
              <li className="flex justify-between gap-4"><span>Zaterdag</span><span className="text-white">9–12</span></li>
              <li className="flex justify-between gap-4"><span>Zondag</span><span className="text-[#E10600]">Gesloten</span></li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-[#1C1D22] flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-[#5A5C63] font-mono-tt">
          <span>© {new Date().getFullYear()} TT MOTORSPORTS — Alle rechten voorbehouden.</span>
          <span>Beekstraat 4C, 8820 Torhout, België</span>
        </div>
      </div>
    </footer>
  );
}
